import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
    Layout, Breadcrumb, Row, Col, Form, Input, Select, Upload, message, Button, Tabs, Modal, Spin, DatePicker, AutoComplete
} from 'antd';
import { HomeOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import JoditEditor from "jodit-react";
import CONSTANT from '../../../config/constant';
import { axiosInstance } from '../../../config/api';
import * as COMMON from '../../../config/common';
import moment from 'moment';
import axios from 'axios';
import { getAccessToken } from 'axios-jwt';
import { GoogleMap, Marker, useLoadScript, StandaloneSearchBox } from '@react-google-maps/api';
const configEditor = {
    height: 300,
    language: 'vi',
    i18n: {
        vi: {
            'Type something': 'Nhập nội dung...',
            'Paste as HTML': 'Dán dưới dạng HTML',
            'Your code is similar to HTML. Keep as HTML?': 'Mã của bạn tương tự như HTML. Giữ dưới dạng HTML?',
            'Keep': 'Giữ',
            'Insert as Text': 'Chèn dưới dạng văn bản',
            'Insert only Text': 'Chỉ chèn văn bản',
            'Cancel': 'Hủy bỏ',
            'Drop image': 'Kéo thả hình ảnh',
            'or click': 'hoặc nhấp vào',
            'Upload': 'Tải lên',
        }
    },
    uploader: {
        url: `${CONSTANT.BASE_API}media/filemanager/uploads`,
        headers: {
            Authorization: `Bearer ${getAccessToken()}`
        },
        data: { type: 'hospital_content' },
        filesVariableName: () => {
            return 'files'
        }
    }
}
const containerStyle = {
    width: '100%',
    height: '50vh',
    marginBottom: '20px'
};
const options = {
    zoomControlOptions: {
        position: "bottom-right"
        // ...otherOptions
    }
}
const status = [
    { value: 'false', label: 'Chờ kiểm duyệt' },
    { value: 'true', label: 'Đã kiểm duyệt' },
];
const userstatus = [
    { value: 'publish', label: 'Công khai' },
    { value: 'draft', label: 'Bản nháp' },
];
const HospitalAction = (props) => {
    const [form] = Form.useForm();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const searchBox = useRef(null);
    /*================= Editor ============== */

    //define variable
    const [typeData, setTypeData] = useState([]);
    const [areaData, setAreaData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [loc, setLoc] = useState(null);
    /*================= Images ============== */
    const [imageList, setImageList] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewImage, setPreviewImage] = useState('');
    const [center, setCenter] = useState({
        lat: 10.779910589838437,
        lng: 106.69988604004955
    });
    /*================= Map ============== */
    const { isLoaded, loadError } = useLoadScript({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDk5UWbkVMJGs5M4-Ns_LRvwMco7F9FdWU",
        libraries: ["places"]
    });
    // Places change address
    const onPlacesChanged = () => {
        const places = searchBox.current.getPlaces();
        if (places && places.length > 0) {
            const location = places[0].geometry.location;
            setCenter({ lat: location.lat(), lng: location.lng() });
            form.setFieldsValue({
                location: `${location.lat()},${location.lng()}`
            });
        }
    };
    // Function to handle marker drag
    const onMarkerDragEnd = (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        setCenter({ lat: newLat, lng: newLng });
        form.setFieldsValue({
            location: `${newLat},${newLng}`
        });
    };
    const onChangeImages = ({ fileList }) => {
        setImageList(fileList);
    }
    const onPreviewImages = async file => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }

        setPreviewImage(src);
        setPreviewVisible(true);
        let _previewTitle = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
        setPreviewTitle(_previewTitle);

    };
    const onRemove = async file => {
        // remove 
    }
    // save image
    const saveImage = async () => {
        let arrImage = [];
        if (imageList.length > 0) {
            for (const item of imageList) {
                if (item.status === 'done') {
                    if (item.response.code === 200 && item.response.data && item.response.data.filename) {
                        let idImage = await axiosInstance.post(`${CONSTANT.API.EXTRA.SAVE_FILE}`, {
                            filename: item.response.data.filename,
                            type: "hospital"
                        })
                            .then(async res => {
                                if (res && res.data && res.data.code === 200) {
                                    let filename = res.data.data.url;
                                    if (typeof filename !== 'undefined') {
                                        return await axiosInstance.post(`${CONSTANT.API.HOSPITAL.IMAGE}`, {
                                            filename
                                        })
                                            .then(mRes => {
                                                if (mRes && mRes.data && mRes.data.code === 200) {
                                                    const { data } = mRes.data;
                                                    if (data) {
                                                        return data._id;
                                                    }
                                                }
                                            }
                                            )
                                    }
                                }
                            });
                        arrImage.push(idImage);
                    }
                }
                else {
                    arrImage.push(item.uid);
                }
            }
        }
        return arrImage;
    };

    /*================= Select ============== */
    const onChangeSelect = (type) => async (value) => {
        switch (type) {
            case 'type':
                break;
            case 'area':
                setCountryData([]);
                setCityData([]);
                form.setFieldsValue({
                    country: null,
                    city: null,
                    district: null
                })
                // load country
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.COUNTRY}?perPage=-1&area=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setCountryData(res.data.data.docs);
                        }
                    });
                break;
            case 'country':
                setCityData([]);
                form.setFieldsValue({
                    city: null,
                    district: null
                })
                // load city
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.CITY}?perPage=-1&country=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setCityData(res.data.data.docs);
                        }
                    });
                break;
            case 'city':
                setDistrictData([]);
                form.setFieldsValue({
                    district: null
                })
                // load district
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.DISTRICT}?perPage=-1&city=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setDistrictData(res.data.data.docs);
                        }
                    });
                break;
            default:
                break;
        }
    }
    const onFinishFailed = async (values) => {
        message.error('Vui lòng nhập đầy đủ thông tin theo yêu cầu, cảm ơn !', 5);
    }
    // submit
    const onFinish = async (values) => {
        setLoading(true);
        values.images = await saveImage();
        values.loc = {
            "coordinates": [
                center.lat,
                center.lng
            ],
            "type": "Point"
        };
        if (!id) {
            await axiosInstance.post(`${CONSTANT.API.HOSPITAL.HOSPITAL}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Cập nhật thông tin thành công.')
                            .then(async () => {
                                loadHospital();
                            })
                    }
                    else {
                        message.error('Cập nhật thông tin thất bại! Vui lòng thử lại sau.');
                        setLoading(false);
                    }

                });
        }
        else {
            await axiosInstance.patch(`${CONSTANT.API.HOSPITAL.HOSPITAL}/${id}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Cập nhật thông tin thành công!')
                            .then(() => {
                                props.history.push('/hospitals')
                            })
                    }
                    else {
                        message.error('Cập nhật thông tin thất bại! Vui lòng thử lại sau.');
                        setLoading(false);
                    }

                });
        }
    };

    // effect
    useEffect(() => {
        // load area
        loadArea();
        // load type
        loadTypeHospital();
        //Load hospital
        loadHospital();
    }, []);

    // load category hospital
    const loadTypeHospital = async () => {
        await axiosInstance.get(`${CONSTANT.API.HOSPITAL.TYPE}?perPage=-1`)
            .then(async res => {
                if (res && res.data && res.data.code === 200) {
                    setTypeData(res.data.data.docs);
                }
            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
    }
    // load Area
    const loadArea = async () => {
        await axiosInstance.get(`${CONSTANT.API.DESTINATION.AREA}?perPage=-1&is_parent=true`)
            .then(res => {
                if (res && res.data && res.data.code === 200) {
                    setAreaData(res.data.data.docs);
                }
            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
    }
    const loadHospital = async () => {
        setLoading(true);
        await axiosInstance.get(`${CONSTANT.API.HOSPITAL.HOSPITAL}/${id}`)
            .then(async res => {
                if (res.data.data && res.data.code === 200) {
                    const data = res.data.data;
                    if (data?.area) {
                        await axiosInstance.get(`${CONSTANT.API.DESTINATION.COUNTRY}?perPage=-1&area=${data?.area._id}`)
                            .then(async res => {
                                if (res && res.data && res.data.code === 200) {
                                    await setCountryData(res.data.data.docs);
                                }

                            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
                    }
                    // load city by country if exist country
                    if (data?.country) {
                        // load city
                        await axiosInstance.get(`${CONSTANT.API.DESTINATION.CITY}?perPage=-1&country=${data?.country._id}`)
                            .then(async res => {
                                if (res && res.data && res.data.code === 200) {
                                    await setCityData(res.data.data.docs);
                                }
                            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
                    }
                    // load district by city if exist city
                    if (data?.city) {
                        // load city
                        await axiosInstance.get(`${CONSTANT.API.DESTINATION.DISTRICT}?perPage=-1&city=${data?.city._id}`)
                            .then(async res => {
                                if (res && res.data && res.data.code === 200) {
                                    await setDistrictData(res.data.data.docs);
                                }
                            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
                    }
                    setLoc(data.loc);
                    form.setFieldsValue({
                        type: data?.type._id,
                        name: data?.name,
                        license_operating: data?.license_operating,
                        license_issue_date: moment(data?.license_issue_date),
                        person_in_charge: data?.person_in_charge,
                        timeserving: data?.timeserving,
                        scope_of_specialty: data?.scope_of_specialty,
                        description: data?.description,
                        introduction: data?.introduction,
                        strengths: data?.strengths,
                        equipment: data?.equipment,
                        ground_plan: data?.ground_plan,
                        process_medical_examination: data?.process_medical_examination,
                        phone: data?.phone,
                        address: data?.address,
                        area: data?.area._id || null,
                        country: data?.country._id || null,
                        city: data?.city._id || null,
                        district: data?.district._id || null,
                        location: data?.loc ? `${data.loc.coordinates[0]},${data.loc.coordinates[1]}` : null,
                        translations: data?.translations,
                        status: data.status,
                        is_active: data.is_active ? 'true' : 'false',
                    });
                    if (data.images && data.images.length > 0) {
                        let images = [];
                        for (let i = 0; i < data.images.length; i++) {
                            let image = data.images[i];
                            images = images.concat({
                                uid: image._id,
                                name: CONSTANT.STATIC_URL + image.filename,
                                status: 'done-add',
                                url: CONSTANT.STATIC_URL + image.filename,
                                thumbUrl: CONSTANT.STATIC_URL + image.filename
                            });
                        }
                        setImageList(images);
                    }
                    setLoading(false);
                }
                else {
                    message.warning('Thông tin cơ sở y tế chưa được tạo. Vui lòng cập nhật thông tin!', 8);
                    setLoading(false);
                }
            })
            .catch(error => { message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error, 5).then(() => props.history.push('/hospitals')); setLoading(false); })
    }
    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Cơ sở y tế
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Thông tin đăng ký
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">
                {
                    loading &&
                    <div style={{ textAlign: 'center' }}>
                        <Spin />
                    </div>
                }

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                        _id: "",
                        name: "",
                        description: "",
                        introduction: '',
                        strengths: '',
                        list_specialty: '',
                        equipment: '',
                        ground_plan: '',
                        process_medical_examination: "",
                        address: "",
                        area: null,
                        country: null,
                        city: null,
                        total_vote: "",
                        loc: null,
                        related: [],
                        facilities: [],
                        specialties: [],
                        images: null,
                        type: null,
                        content: ''
                    }}>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={18}>
                            <Tabs defaultActiveKey="vi" type="card" size="large">
                                <Tabs.TabPane tab="Tiếng Việt" key="vi" forceRender={true}>
                                    <Row gutter={24}>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Loại cơ sở y tế"
                                                name="type"
                                                required tooltip="Trường bắt buộc nhập"
                                                rules={[
                                                    { required: true, message: 'Vui lòng chọn loại cơ sở y tế !' }
                                                ]}
                                            >
                                                <Select
                                                    placeholder="Chọn loại cơ sở y tế"
                                                    optionFilterProp="children"
                                                    onChange={onChangeSelect('type')}
                                                    style={{ width: '100%' }}>
                                                    {
                                                        typeData.length > 0 &&
                                                        typeData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={14} md={18}>
                                            <Form.Item
                                                label="Tên cơ sở y tế"
                                                name="name"
                                                required tooltip="Trường bắt buộc nhập"
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập tên cơ sở y tế!' },
                                                ]}
                                            >
                                                <Input placeholder="Tên cơ sở y tế" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col xs={24} sm={14} md={6}>
                                            <Form.Item
                                                label="Giấy phép hoạt động"
                                                name="license_operating"
                                                required tooltip="Trường bắt buộc nhập"
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập giấy phép !' },
                                                    { max: 30, message: 'Tối đa 30 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Nhập giấy phép hoạt động" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={14} md={6}>
                                            <Form.Item label="Ngày cấp" name="license_issue_date">
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    showNow={false}
                                                    placeholder="Chọn ngày cấp"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Thời gian làm việc"
                                                name="timeserving"
                                                rules={[
                                                    { max: 50, message: 'Tối đa 50 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Nhập thời gian làm việc" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Điện thoại liên hệ"
                                                name="phone"
                                                rules={[
                                                    { max: 25, message: 'Điện thoại tối đa 25 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Điện thoại liên hệ" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={12}>
                                            <Form.Item
                                                label="Địa chỉ"
                                                required
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập địa chỉ !' },
                                                    { max: 150, message: 'Tối đa 150 ký tự !' }
                                                ]}
                                                name={'address'}
                                            >
                                                <Input placeholder="Nhập địa chỉ" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={12}>
                                            <Form.Item
                                                label="Người phụ trách chuyên môn"
                                                name="person_in_charge"
                                                rules={[
                                                    { required: true, message: 'Vui lòng chọn loại cơ sở y tế !' }
                                                ]}
                                            >
                                                <Input placeholder="Người phụ trách chuyên môn" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item
                                        label="Phạm vị chuyên môn"
                                        name="scope_of_specialty"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập phạm vị chuyên môn !' }
                                        ]}
                                    >
                                        <Input placeholder="Nhập phạm vị chuyên môn" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Mô tả" name="description"
                                        tooltip="Mô tả ngắn gọn"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập mô tả ngắn gọn' },
                                        ]}>
                                        <Input.TextArea placeholder="Nhập mô tả ngắn gọn" rows={2} />
                                    </Form.Item>
                                    <Form.Item label="Giới thiệu chung"
                                        name="introduction"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập giới thiệu chung' },
                                        ]}>
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item label="Thế mạnh chuyên môn"
                                        name="strengths"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Trang thiết bị"
                                        name="equipment"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Sơ đồ mặt bằng"
                                        name="ground_plan"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Quy trình khám"
                                        name="process_medical_examination"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                </Tabs.TabPane>
                                <Tabs.TabPane forceRender={true} tab="Tiếng Anh" key="en">
                                    <Row gutter={24}>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Loại cơ sở y tế"
                                                name="type"
                                                required tooltip="Trường bắt buộc chọn"
                                                rules={[
                                                    { required: true, message: 'Vui lòng chọn loại cơ sở y tế !' }
                                                ]}
                                            >
                                                <Select
                                                    placeholder="Chọn loại cơ sở y tế"
                                                    optionFilterProp="children"
                                                    onChange={onChangeSelect('type')}
                                                    style={{ width: '100%' }}>
                                                    {
                                                        typeData.length > 0 &&
                                                        typeData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={14} md={18}>
                                            <Form.Item
                                                label="Tên cơ sở y tế"
                                                name={['translations', 'en', 'name']}
                                                required tooltip="Trường bắt buộc nhập"
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập tên cơ sở y tế!' },
                                                ]}
                                            >
                                                <Input placeholder="Tên cơ sở y tế" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col xs={24} sm={14} md={6}>
                                            <Form.Item
                                                label="Giấy phép hoạt động"
                                                name={'license_operating'}
                                                required tooltip="Trường bắt buộc nhập"
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập giấy phép !' },
                                                    { max: 30, message: 'Tối đa 30 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Nhập giấy phép hoạt động" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={14} md={6}>
                                            <Form.Item label="Ngày cấp" name="license_issue_date">
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    showNow={false}
                                                    placeholder="Chọn ngày cấp"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Thời gian làm việc"
                                                name="timeserving"
                                                rules={[
                                                    { max: 50, message: 'Tối đa 50 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Nhập thời gian làm việc" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={10} md={6}>
                                            <Form.Item
                                                label="Điện thoại liên hệ"
                                                name="phone"
                                                rules={[
                                                    { max: 25, message: 'Điện thoại tối đa 25 ký tự !' }
                                                ]}
                                            >
                                                <Input placeholder="Điện thoại liên hệ" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={12}>
                                            <Form.Item
                                                label="Địa chỉ"
                                                name={['translations', 'en', 'address']}
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập địa chỉ !' },
                                                    { max: 150, message: 'Tối đa 150 ký tự !' }
                                                ]}

                                            >
                                                <Input placeholder="Nhập địa chỉ" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={10} md={12}>
                                            <Form.Item
                                                label="Người phụ trách chuyên môn"
                                                name={['translations', 'en', 'person_in_charge']}
                                                rules={[
                                                    { required: true, message: 'Vui lòng chọn loại cơ sở y tế !' }
                                                ]}
                                            >
                                                <Input placeholder="Người phụ trách chuyên môn" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item
                                        label="Phạm vị chuyên môn"
                                        name={['translations', 'en', 'scope_of_specialty']}
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập phạm vị chuyên môn !' }
                                        ]}
                                    >
                                        <Input placeholder="Nhập phạm vị chuyên môn" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Mô tả"
                                        name={['translations', 'en', 'description']}
                                        tooltip="Mô tả ngắn gọn"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập mô tả ngắn gọn' },
                                        ]}>
                                        <Input.TextArea placeholder="Nhập mô tả ngắn gọn" rows={4} />
                                    </Form.Item>
                                    <Form.Item label="Giới thiệu chung"
                                        name={['translations', 'en', 'introduction']}
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập giới thiệu chung' },
                                        ]}>
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item label="Thế mạnh chuyên môn"
                                        name={['translations', 'en', 'strengths']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Trang thiết bị"
                                        name={['translations', 'en', 'equipment']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Sơ đồ mặt bằng"
                                        name={['translations', 'en', 'ground_plan']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Quy trình khám"
                                        name={['translations', 'en', 'process_medical_examination']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                </Tabs.TabPane>
                            </Tabs>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                            {/* Begin Images */}
                            <Form.Item label="Hình ảnh">
                                <ImgCrop
                                    rotate
                                    modalTitle="Sửa ảnh"
                                    modalOk="Đồng ý"
                                    aspect={800 / 600}
                                    quality={0.8}
                                    modalWidth={800}
                                >
                                    <Upload
                                        listType="picture-card"
                                        action={`${CONSTANT.API.EXTRA.UPLOAD_IMAGE}`}
                                        fileList={imageList}
                                        onPreview={onPreviewImages}
                                        onChange={onChangeImages}
                                        headers={{
                                            'X-TK': CONSTANT.API.KEY
                                        }}
                                        onRemove={onRemove}
                                    >
                                        {
                                            imageList.length < 15 &&
                                            <div>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>Chọn hình</div>
                                            </div>
                                        }
                                    </Upload>
                                </ImgCrop>
                                <Modal
                                    visible={previewVisible}
                                    title={previewTitle}
                                    footer={null}
                                    onCancel={() => setPreviewVisible(false)}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                            </Form.Item>
                            {/* End Images */}
                            <Form.Item label="Khu vực"
                                name="area"
                                required tooltip="Khu vực: Châu Á, Châu Âu, Châu Mỹ"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn khu vực!' }
                                ]}>
                                <Select
                                    placeholder="Chọn khu vực"
                                    onChange={onChangeSelect('area')}
                                    style={{ width: '100%' }}>
                                    {
                                        areaData.length > 0 &&
                                        areaData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item label="Quốc gia"
                                name="country"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn quốc gia!' }
                                ]}>
                                <Select
                                    showSearch
                                    placeholder="Chọn quốc gia"
                                    optionFilterProp="children"
                                    onChange={onChangeSelect('country')}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onFocus={COMMON.offAutoCompleteSelect()}>
                                    {
                                        countryData.length > 0 &&
                                        countryData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Thành phố"
                                name="city"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn thành phố!' }
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Chọn thành phố"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onChange={onChangeSelect('city')}
                                    onFocus={COMMON.offAutoCompleteSelect()}
                                >
                                    {
                                        cityData.length > 0 &&
                                        cityData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Quận/huyện"
                                name="district"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn quận/huyện!' }
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Chọn quận/huyện"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onFocus={COMMON.offAutoCompleteSelect()}
                                >
                                    {
                                        districtData.length > 0 &&
                                        districtData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label='Tọa độ hiện tại'
                                name="location"
                                tooltip={'Vui lòng nhập địa chỉ vào ô tìm địa điểm và chọn địa điểm để hiển thị tọa độ của vị trí, hoặc có thể kéo thả điểm để điều chỉnh tọa độ'}
                                rules={[
                                    { required: true, message: 'Vui lòng nhập tọa độ !' },
                                    {
                                        type: 'string', max: 50, message: 'Tối đa 50 ký tự !'
                                    }
                                ]}>
                                <Input placeholder='Nhập tọa độ' />
                            </Form.Item>
                            {
                                isLoaded ?
                                    <GoogleMap
                                        mapContainerStyle={containerStyle}
                                        center={center}
                                        zoom={15}
                                        options={options}
                                    >
                                        <Marker
                                            position={center}
                                            draggable={true}
                                            onDragEnd={onMarkerDragEnd}
                                        />
                                        <StandaloneSearchBox
                                            onLoad={(ref) => (searchBox.current = ref)}
                                            onPlacesChanged={onPlacesChanged}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Tìm địa điểm"
                                                style={{
                                                    boxSizing: `border-box`,
                                                    border: `1px solid transparent`,
                                                    width: `300px`,
                                                    height: `32px`,
                                                    padding: `0 12px`,
                                                    borderRadius: `3px`,
                                                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                    fontSize: `14px`,
                                                    outline: `none`,
                                                    textOverflow: `ellipses`,
                                                    position: "absolute",
                                                    left: "10px",
                                                    right: "10px",
                                                    top: '60px'
                                                }}
                                            />
                                        </StandaloneSearchBox>
                                    </GoogleMap>
                                    :
                                    <div>Xin lỗi không thể load map bây giờ!.</div>
                            }
                            <Form.Item label="Kích hoạt bởi người dùng" name="status">
                                <Select
                                    placeholder="Kích hoạt bởi người dùng"
                                    style={{ width: '100%' }}>
                                    {
                                        userstatus.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item label="Trạng thái" name="is_active">
                                <Select
                                    placeholder="Kiểm duyệt"
                                    style={{ width: '100%' }}>
                                    {
                                        status.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className="footer-toolbar">
                        <div className="right">
                            <Button type="primary" icon={<SaveOutlined />}
                                htmlType="submit" data-tour="hospital-1" loading={loading}
                            >
                                Lưu thông tin
                            </Button>
                        </div>

                    </div>
                </Form>
                {/* <ModalShowMap
                    visible={isModalMapVisible}
                    cancel={(data) => {
                        setIsModalMapVisible(false);
                    }}
                    data={loc}
                /> */}
            </Layout.Content>
        </div>
    )

}

export default HospitalAction;
